import { connect } from "react-redux";
import { ReactTitle } from "react-meta-tags";
import MainTemplate from "../../mainTemplate";
import { withTranslation } from "react-i18next";
import React, { Component, Fragment } from "react";
import Tabs from "../../../public/tableProvider/tabs";

import ClientUsers from "../users/";
import RelatedCompanies from "./RelatedCompanies";
import SwitchEditClient from "../institutionProfile/switchEdit";
import ProvidersClient from "../institutionProfile/providers-client";
import Services from "../services/institutionServices";
import Waivers from "./waivers";
import SpecialConditions from "./specialConditions";

export class InstitutionMain extends Component {
  render() {
    const { t } = this.props;
    return (
      <MainTemplate>
        <ReactTitle title={t("clients.profile.meta.title")} />
        <div className="client-profile">
          <h2 className="client">
            {this.props.institution.name !== undefined && (
              <Fragment>
                <img
                  src={`data:image/png;base64,${this.props.institution.country.flag}`}
                />
                {this.props.institution.name} /{" "}
                {this.props.institution.businessId}
              </Fragment>
            )}
          </h2>
          <div className="header-tabs">
            <Tabs>
              <div label={t("clients.profile.tabs.profile")}>
                <SwitchEditClient />
              </div>
              <div label={t("clients.profile.tabs.related")}>
                <RelatedCompanies />
              </div>
              <div label={t("clients.profile.tabs.services")}>
                <Services />
              </div>
              <div label={t("clients.profile.tabs.users")}>
                <ClientUsers />
              </div>
              <div label={t("clients.profile.tabs.providers")}>
                <ProvidersClient />
              </div>
              <div label={t("clients.profile.tabs.waivers")}>
                <Waivers />
              </div>
              <div label={t("clients.profile.tabs.specialCodition")}>
                <SpecialConditions
                  companyId={this.props.institution.company?.id}
                  code={this.props.institution?.country?.code}
                />
              </div>
            </Tabs>
          </div>
        </div>
      </MainTemplate>
    );
  }
}

export const mapState = (state) => ({
  institution: state.clientReducer.institution,
});

export default connect(mapState, null)(withTranslation()(InstitutionMain));
